<script setup>
// Lopes & Co. (E23, 03/10/2026): o Kanban da plataforma como tela do Chatwoot (item "Kanban" do menu lateral), no lugar da aba
// de Dashboard App dentro da conversa. A tela mostra o /kanban/embutido do portal em tela cheia. O endereço (com o token
// assinado da conta) vem do Dashboard App "Kanban" que o portal mantém em cada conta (padrao_conta.py) — aqui não mora segredo
// nenhum. O contexto (agente que move o cartão, tema claro/escuro) vai pelo mesmo protocolo do Dashboard App: o iframe pede
// `chatwoot-dashboard-app:fetch-info` e recebe `appContext`.
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';

const store = useStore();
const apps = useMapGetter('dashboardApps/getRecords');
const usuario = useMapGetter('getCurrentUser');
const frame = ref(null);
const buscou = ref(false);
const carregando = ref(true);

const url = computed(() => {
  const app = (apps.value || []).find(a => a.title === 'Kanban');
  const item = (app?.content || []).find(c => c.type === 'frame' && c.url);
  if (!item) return '';
  const u = new URL(item.url);
  u.searchParams.set('tela', 'cheia');
  return u.toString();
});
const portal = computed(() => (url.value ? `${new URL(url.value).origin}/kanban` : ''));

const tema = () =>
  document.documentElement.classList.contains('dark') ||
  document.body.classList.contains('dark')
    ? 'escuro'
    : 'claro';

const enviarContexto = () => {
  const alvo = frame.value?.contentWindow;
  if (!alvo) return;
  const { id, name, email } = usuario.value || {};
  const dados = {
    currentAgent: { id, name, email },
    conversation: null,
    contact: null,
    tela: 'cheia',
    tema: tema(),
  };
  alvo.postMessage(JSON.stringify({ event: 'appContext', data: dados }), '*');
  carregando.value = false;
};

const aoMensagem = ev => {
  if (
    ev.data === 'chatwoot-dashboard-app:fetch-info' &&
    frame.value &&
    ev.source === frame.value.contentWindow
  ) {
    enviarContexto();
  }
};

onMounted(async () => {
  window.addEventListener('message', aoMensagem);
  try {
    await store.dispatch('dashboardApps/get');
  } finally {
    buscou.value = true;
  }
});
onUnmounted(() => window.removeEventListener('message', aoMensagem));
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header
      class="flex items-center justify-between gap-2 px-6 py-4 border-b border-n-weak"
    >
      <span class="text-xl font-medium truncate text-n-slate-12">Kanban</span>
      <a
        v-if="portal"
        :href="portal"
        target="_blank"
        rel="noopener"
        class="text-sm text-n-slate-11 hover:text-n-slate-12"
      >
        Abrir no portal ↗
      </a>
    </header>
    <div class="relative flex-1 min-h-0">
      <div
        v-if="url && carregando"
        class="absolute inset-0 flex items-center justify-center text-sm text-n-slate-11"
      >
        Carregando o Kanban…
      </div>
      <iframe
        v-if="url"
        ref="frame"
        :src="url"
        title="Kanban"
        class="w-full h-full border-0"
        @load="enviarContexto"
      />
      <div
        v-else-if="buscou"
        class="flex items-center justify-center h-full p-8 text-sm text-n-slate-11"
      >
        O Kanban ainda não foi configurado nesta conta. Fale com a Lopes & Co.
      </div>
    </div>
  </section>
</template>
